var a="isolated-page-app-container";export{a as ISOLATED_PAGE_APP_CONTAINER_ID};
